module.exports = __webpack_public_path__ + "img/calendar-alt-solid.c0735707.svg";